import { render, staticRenderFns } from "./vehicle_page.vue?vue&type=template&id=744e3b4e&scoped=true"
import script from "./vehicle_page.vue?vue&type=script&lang=js"
export * from "./vehicle_page.vue?vue&type=script&lang=js"
import style0 from "./vehicle_page.vue?vue&type=style&index=0&id=744e3b4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744e3b4e",
  null
  
)

export default component.exports